import { useEffect, useState } from 'react'
import { UseLoadSdk } from './use-load-sdk.types'
import { waitForCondition } from '@yuno/sdk-web-core/dist/utils/wait'

export const useLoadSdkYuno: UseLoadSdk = () => {
  const [isYunoLoaded, setIsYunoLoaded] = useState(false)

  useEffect(() => {
    if (window.Yuno) {
      setIsYunoLoaded(true)
      return
    }

    const waitLoadYuno = async() => {
      const isAviableYuno = await waitForCondition({
        conditionFn: () => window.Yuno,
      })
      if (isAviableYuno) {
        setIsYunoLoaded(true)
      }
    }
    waitLoadYuno()
  }, [])

  return { isYunoLoaded }
}

